// extracted by mini-css-extract-plugin
export default {"cell":"TableViewCell_cell__pdGiA","icon":"TableViewCell_icon__XKpmD","content":"TableViewCell_content__WceZ6"};